import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="readablestream" id="readablestream"></a>
    <h1 {...{
      "id": "windowreadablestream"
    }}>{`window.ReadableStream`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream"
      }}>{`Web APIs - ReadableStream`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: UXP v6.1  `}</p>
    <a name="new-readablestream-new" id="new-readablestream-new"></a>
    <h2 {...{
      "id": "readablestreamunderlyingsource-strategy"
    }}>{`ReadableStream(underlyingSource, strategy)`}</h2>
    <p>{`Creates a ReadableStream object from the given handlers.`}</p>
    <br></br>Note that `underlyingSource.type` and `underlyingSource.autoAllocateChunkSize` are not supported.
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`ReadableStream`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`underlyingSource`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Define how the constructed stream instance will behave.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`underlyingSource.start(controller)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Called immediately when the object is constructed.          This method needs to do anything else required to set up the stream functionality.          If this process is to be done asynchronously, it can return a promise to signal success or failure.          The controller parameter passed to this method is a ReadableStreamDefaultController.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`underlyingSource.pull(controller)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Called repeatedly when the stream's internal queue of chunks is not full,          up until it reaches its high water mark.          If pull() returns a promise, then it won't be called again until that promise fulfills.          If the promise rejects, the stream will become errored.          The controller parameter passed to this method is a ReadableStreamDefaultController.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`underlyingSource.cancel(reason)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Called if the app signals that the stream is to be cancelled.          The contents should do whatever is necessary to release access to the stream source.          If this process is asynchronous, it can return a promise to signal success or failure.          The reason parameter contains a string describing why the stream was cancelled.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`strategy`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Defines a queuing strategy for the stream.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`strategy.highWaterMark`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Defines the total number of chunks that can be contained in the internal queue          before backpressure is applied.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`strategy.size(chunk)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates the size to use for each chunk, in bytes.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="readablestream-locked" id="readablestream-locked"></a>
    <h2 {...{
      "id": "locked--boolean"
    }}>{`locked : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Indicate whether the readable stream is locked.`}</p>
    <a name="readablestream-cancel" id="readablestream-cancel"></a>
    <h2 {...{
      "id": "cancelreason"
    }}>{`cancel(reason)`}</h2>
    <p>{`Cancel the readable stream.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the source stream is not a ReadableStream or it's locked.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`reason`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`reason for the cancellation.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="readablestream-getreader" id="readablestream-getreader"></a>
    <h2 {...{
      "id": "getreaderoptions"
    }}>{`getReader(options)`}</h2>
    <p>{`Create a reader and lock the stream to it.`}</p>
    <br></br>Note that currently ReadableStreamDefaultReader object is returned as options.mode <b>"byob" is not supported.</b>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`ReadableStreamDefaultReader`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` when options`}{`["mode"]`}{` does not equal to undefined.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Object with mode property.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.mode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ReadableStreamDefaultReader being created, defaults to `}<inlineCode parentName="td">{`undefined`}</inlineCode>{` and `}<inlineCode parentName="td">{`byob`}</inlineCode>{` is not yet supported.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="readablestream-pipethrough" id="readablestream-pipethrough"></a>
    <h2 {...{
      "id": "pipethroughtransform-options"
    }}>{`pipeThrough(transform, options)`}</h2>
    <p>{`Provides a chainable way of piping the current stream through a transform stream.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`ReadableStream`}</inlineCode>{` - ReadableStream of the input transform stream.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the source stream is not a ReadableStream.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the input transform stream is not valid.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the source readable stream is locked.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the writable stream of the input transform stream is locked.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if options is not valid.`}</li>
    </ul>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.0.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`transform`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`TransformStream`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`WritableAndReadable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`TransformStream or an object with the structure {writable, readable}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.preventClose`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If true, the source ReadableStream closing will no loger cause the destination WritableStream          to be closed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.preventAbort`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If true, errors in the source ReadableStream will no longer abort the destination WritableStream.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.preventCancel`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If true, errors in the destination WritableStream will no longer cancel the source ReadableStream.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.signal`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`AbortSignal`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If aborted, ongoing pipe operations can be aborted.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="readablestream-pipeto" id="readablestream-pipeto"></a>
    <h2 {...{
      "id": "pipetodestination-options"
    }}>{`pipeTo(destination, options)`}</h2>
    <p>{`Pipes this readable stream to a given writable stream destination.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode>{` resolves when the piping process has completed.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the source stream is not a ReadableStream.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the destination is not a WritableStream.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the source ReadableStream is locked.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the destination WritableStream is locked.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if options is not valid.`}</li>
    </ul>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.0.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`destination`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`WritableStream`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Final destination for the ReadableStream.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(Optional) Used when piping to the writable stream.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.preventClose`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If true, the source ReadableStream closing will no loger cause the destination WritableStream to be closed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.preventAbort`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If true, errors in the source ReadableStream will no longer abort the destination WritableStream.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.preventCancel`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If true, errors in the destination WritableStream will no longer cancel the source ReadableStream.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options.signal`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`AbortSignal`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If aborted, ongoing pipe operations can be aborted.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="readablestream-tee" id="readablestream-tee"></a>
    <h2 {...{
      "id": "tee"
    }}>{`tee()`}</h2>
    <p>{`Tees the current ReadableStream, returning a two-element array
containing the two resulting branches as new ReadableStream instances.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Array`}</inlineCode>{` - an array containing two ReadableStream instances.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the source stream is not a ReadableStream.`}</li>
    </ul>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.0.0  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      